// This is a no-op since we have the latest files on web always
const useOTAUpdates = () => {}

export default useOTAUpdates
